import React, { useState } from "react";
import { BehaviorSubject } from "rxjs";
import PropTypes from "prop-types";
import Tag from "../../models/Tag";
import HoverClickTooltip from "../../../atoms/Tooltip/HoverClickTooltip";
import { TAG_COLOR, TAG_BG, TAG_TITLES } from "../../constants/tagConstants";

function TagPill({ tag, children, highlighted$, selected$ }) {
  const [isSelected, setIsSelected] = useState(false);
  const trCl = "tw-transition-all tw-duration-200";
  const { url } = tag;
  const cl = "tw-rounded-lg tw-font-semibold tw-mr-1 tw-px-1";
  const colorCl = isSelected ? "tw-text-white" : TAG_COLOR[tag.tagType];
  const bgCl = TAG_BG[tag.tagType];
  const hoverCl = isSelected ? "" : "hover:tw-bg-opacity-20 tw-bg-opacity-0";

  return (
    <div
      className="tw-inline-block tw-cursor-pointer tw-flex-shrink-0"
      data-tab="none"
    >
      <div className={`${colorCl} ${bgCl} ${cl} ${trCl} ${hoverCl} tw-flex`}>
        <HoverClickTooltip
          className="publications-tooltip"
          disabled={!isSelected}
          ContentRenderer={() => {
            return (
              <div className="tw-text-xs">
                {url ? (
                  <div className="tw-flex tw-items-center">
                    <a href={url} target="_blank" title="open in VarSome">
                      VarSome <i className="fa fa-external-link" />
                    </a>
                  </div>
                ) : null}
                {tag.normalized}: {TAG_TITLES[tag.tagType]}
                <div className="tw-w-2 tw-inline-block" />
                <div
                  className={`tw-inline-block tw-h-2 tw-w-2 tw-rounded-full ${bgCl}`}
                />
              </div>
            );
          }}
        >
          <>
            <div
              onMouseEnter={() => {
                highlighted$.next({ typeKey: tag.typeKey, autoScroll: true });
              }}
              onMouseLeave={() => highlighted$.next(new Set())}
              onClick={() => {
                if (isSelected) {
                  setIsSelected(false);
                  const selection = selected$.value;
                  selection.delete(tag.typeKey);
                  selected$.next(selection);
                } else {
                  setIsSelected(true);
                  const selection = selected$.value;
                  selection.add(tag.typeKey);
                  selected$.next(selection);
                }
              }}
            >
              {tag.normalized}
            </div>
            {children}
          </>
        </HoverClickTooltip>
      </div>
    </div>
  );
}

TagPill.propTypes = {
  tag: PropTypes.instanceOf(Tag).isRequired,
  highlighted$: PropTypes.instanceOf(BehaviorSubject).isRequired,
  selected$: PropTypes.instanceOf(BehaviorSubject).isRequired,
  children: PropTypes.node,
};

TagPill.defaultProps = {
  children: null,
};

export default TagPill;
